import { render, staticRenderFns } from "./NumbersDiff.vue?vue&type=template&id=7184953c&scoped=true&"
import script from "./NumbersDiff.vue?vue&type=script&lang=js&"
export * from "./NumbersDiff.vue?vue&type=script&lang=js&"
import style0 from "./NumbersDiff.vue?vue&type=style&index=0&id=7184953c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7184953c",
  null
  
)

export default component.exports